"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _excluded = ["html"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// known bug of DOMPurify in conjunction with onbeforeprint event. we can disregard it.
// https://github.com/cure53/DOMPurify/issues/529
var DOMPurifyErrorRegex = /Failed to execute '.*?' on '.*?': The provided callback is no longer runnable\./;
_dompurify["default"].addHook('afterSanitizeAttributes', function (node) {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});
function HBSanitized(_ref, ref) {
  var html = _ref.html,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var sanitizedHtml = (0, _react.useMemo)(function () {
    if (!html) {
      return '';
    }
    try {
      return _dompurify["default"].sanitize(html, {
        ADD_ATTR: ['target', 'rel']
      });
    } catch (error) {
      if (DOMPurifyErrorRegex.test(error.message)) {
        return '';
      }
      throw error;
    }
  }, [html]);
  if (sanitizedHtml) {
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      ref: ref
    }, props, {
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: {
        __html: sanitizedHtml
      }
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref
  }, props));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(HBSanitized);
//# sourceMappingURL=HBSanitized.js.map